import { FC } from 'react';

import { Button } from '@rikstv/play-common/src/components/button';
import { DialogProps } from '@rikstv/play-common/src/components/coverPage/coverpage.types';
import { PlayerDialog } from '@rikstv/play-common/src/components/playerDialog';
import { authService } from '@rikstv/play-common/src/utils/auth/AuthService';
import { Body } from '@rikstv/shared-components';

import { usePlayerSignupDialog } from './usePlayerSignupDialog';

const handleLoginClick = () => authService.login();
const FooterText: FC = () => {
  return (
    <Body>
      Allerede kunde?{' '}
      <Button buttonStyle="inline-link" onClick={handleLoginClick}>
        Logg inn
      </Button>
      !
    </Body>
  );
};
export const PlayerSignupDialog: FC<DialogProps['Signup']> = ({ posterUrl, assetOrChannel }) => {
  const { recommendedProductsUrl, buttonText } = usePlayerSignupDialog(assetOrChannel);

  return (
    <PlayerDialog
      buttonText={buttonText}
      linkOrClickHandler={recommendedProductsUrl}
      footer={<FooterText />}
      posterUrl={posterUrl}
    />
  );
};
